import { gql } from '@apollo/client';

export const SENDER_ID = gql`
  query($storeId: String!) {
    senderId(restaurantId: $storeId)
  }
`;
